/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState: {
    appToken: '',
    idProcess: '', // ID to send to the loggin api and payment transactions
    quoterCurrentStep: 1,
    quoterTotalSteps: 7,
  },
  reducers: {
    setAppToken(state, { payload }) {
      state.appToken = payload.token;
    },
    setIdProcess(state, { payload }) {
      state.idProcess = payload.idProcess;
    },
    setQuoterCurrentStep(state, { payload }) {
      state.quoterCurrentStep = payload.newQuoterStep;
    },
  },
});

export const appConfigActions = appConfigSlice.actions;

export default appConfigSlice;
/* eslint-enable no-param-reassign */
